<template>
  <div id="app">
    <transition name="slide-fade">
      <header v-show="showHeader" :class="{hidden: !showHeader}" class="header flex-apart">
        <div class="header-logo">
          <a :href="(!code || code==='BE51')?'/':('/v/'+code)"><img alt="Vote Background" src="/img/iVOTE@2x.png"
                                                                    width="auto"
                                                                    height="32"/></a>
        </div>
        <div class="header-menu">
          <span @click="isSidebarOpen=true"><i class="fa fa-ellipsis-v"/></span>
        </div>
      </header>
    </transition>
    <sidebar :key="sideBarRender" @resetVotes="resetVotes" @logout="logout" @createNew="createNew"
             @deleteVote="deleteVote"
             @closeSidebar="closeSidebar" @updateTvMode="updateTvMode" @updateHe="updateHe"
             @addCategory="addCategory" @selectCategory="selectCategory" @editCategory="editCategory"
             @checkCodeTest="checkCodeTest" @openLeadersBoard="openLeadersBoard"
             @saveSettings="saveSettings(true)" @openFullscreen="openFullscreen" @getQR="getQR"
             @openGuests="openGuests"
             :code="code" :user="user" :votes-list="myVotesList" :voteId="id"
             :allow-edit="allowEdit"
             :votes-count="votesCategory.length" :settings="settings" :isOpen="isSidebarOpen" :img-quality="imgQuality"
             :he="settings.he" :locked="locked" :access-token="accessToken"
             :tv-mode="tvMode" :categories="categories" :players="players" :locals="locals"
             :results-only="isResultsOnly"
             :selectedCategoryId="category? category.id:-1" :guests-count="guests.length"/>
    <edit-modal v-if="user && allowEdit" @removePlayer="removePlayer" @savePlayer="savePlayer" :img-quality="imgQuality"
                :user-id="user.id"
                :player="playerEdited"
                :show-modal="showModal"></edit-modal>
    <guests-modal v-if="user && allowEdit" @closeGuestsModal="closeGuestsModal"
                  :guests="guests" :show-guests-modal="showGuestsModal"></guests-modal>
    <search-modal v-if="allowEdit" @addExistingPlayer="addExistingPlayer" :players="players"
                  :category-players="categoryPlayers"
                  :show-modal="showSearchModal" @closeSearch="showSearchModal=false"
                  @addPlayer="addPlayer"></search-modal>
    <category-edit-modal v-if="user && allowEdit" @removeCategory="removeCategory"
                         @saveCategories="saveCategories"
                         :img-quality="imgQuality"
                         :user-id="user.id"
                         :category="category" :category-players="categoryPlayers"
                         :show-modal="showCategoryModal"></category-edit-modal>
    <div v-if="tvMode">
      <div class="players players-tv"
           :style="{'grid-template-columns': 'repeat('+settings.cols+', '+(100/settings.cols)+'vw)', 'grid-template-rows': 'repeat('+settings.rows+', auto)'}">
        <div :style="{'background-image': 'url('+p.img+')'}"
             :key="'p-'+k" class="players-item"
             v-for="(p,k) in topPlayers">
          <span v-show="settings.showScore" class="player-score">{{ p.score }}</span>
          <span :style="{'font-size': (12/settings.cols)+'vw'}" v-show="p.name && !p.hideName"
                class="player-name">{{ p.name }}</span>
          <div class="fav-container">
               <span :key="'p-'+k+'-'+j" class="fav-group"
                     :style="{'background-color':settings.theme+'AA'}"
                     v-for="(f,j) in p.fav">
            <span>{{ f }}</span><span>#1</span>
          </span>
          </div>
          <span class="overlay" :class="{boomerang:p.img2}"
                :style="{'background-image':p.img2?('url('+p.img2+')'):''}"></span>
        </div>
      </div>
      <div class="overlay overlay-dark"
           v-show="showLeaders && getPlayer(category.playerId) || showLeadingCandidates"></div>
      <transition name="slide-fade">
        <div class="leaders-modal" v-if="showLeaders && getPlayer(category.playerId)"
             :style="{'background-color':settings.theme, 'background-image':settings.theme?'unset':''}">
          <div class="row">
            <div class="col-md-5 leaders-modal-left">
              <img alt="Category" :src="category.images['main']" width="100%" height="auto">
              <div class="players-item">
                <img alt="Leader" :src="getPlayer(category.playerId).img" width="100%" height="auto">
                <div class="player-name"
                     :style="{'background-image':(settings.theme?'':`url(assets/img/player-bg.jpg)`)}">
                  <span>{{ getPlayer(category.playerId).name }}</span>
                  <span v-show="getPlayer(category.playerId).details">{{ getPlayer(category.playerId).details }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-7 leaders-modal-right">
              <div class="leaders-list">
                <label @click="openAlert('טלפון '+l.tel)" :key="'ll-'+k"
                       v-for="(l,k) in leadersList"><strong>{{ ((k + 1) + "").padStart(2, '0') }}</strong>{{
                    l.name
                  }}</label>
              </div>
              <div class="leaders-footer">
                <label class="leaders-voters">
                  <span :style="{'background-color':settings.theme}">{{
                      trans('correct')
                    }} {{ votesCurrCategoryCorrect + '%' }}</span>
                  <span>{{ trans('wrong') }} {{ votesCurrCategoryWrong + '%' }}</span>
                </label>
                <label class="leaders-category">{{ category.name }}</label>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="leading-candidates-modal" v-if="showLeadingCandidates && leader"
             :style="{'background-color':settings.theme, 'background-image':settings.theme?'unset':''}">
          <div class="row">
            <div class="col-12">
              <div class="players-item">
                <img alt="Leader" :src="leader.img" width="100%" height="auto">
                <div class="player-name">
                  <span>{{ leader.name }}</span>
                  <span>{{ leader.details }}</span>
                </div>
                <label class="player-score"
                       :style="{'background-color':settings.theme, 'background-image':settings.theme?'unset':''}">{{
                    leader.score
                  }}<small>נקודות</small></label>
                <label class="player-position"><i class="fas fa-medal"></i>{{ leadingCandidate }}</label>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-else class="app-wrapper">
      <transition name="fade">
        <section v-if="screen<=1" class="welcome" :style="{'background-color':settings.theme}">
          <div class="container" :class="{'no-start-button': !settings.startButton}"
               :style="{'background-image':'url('+settings.background+')', 'background-color':settings.theme}">
            <div v-if="!user && !allowEdit" class="welcome-screen-btn" @click="start"></div>
            <input @change="saveSettings" :disabled="!allowEdit" v-model="settings.title"
                   v-show="allowEdit||!settings.hideTitles"
                   class="title hidden-input">
            <input @change="saveSettings" :disabled="!allowEdit" v-model="settings.subtitle"
                   v-show="allowEdit||!settings.hideTitles"
                   class="subtitle hidden-input">
            <img class="welcome-logo" id="main-logo" v-show="allowEdit"
                 :src="settings.logo ? settings.logo:'/img/upload.png'"
                 alt="Upload Logo">
            <avatar-cropper v-if="user"
                            @uploaded="handleUploadedLogo"
                            trigger="#main-logo"
                            upload-url="https://ivote.tv/api/"
                            :upload-form-data="{userId:user.id}"
                            :output-quality="imgQuality"
                            :output-options="{width: 256, height: 256}"
                            :labels="{ submit: trans('approve'), cancel: trans('cancel')}"/>
          </div>
          <button v-show="settings.startButton" :disabled="screen===0 || !settings.allowVote" @click="start" class="btn"
                  :class="{'btn-start':screen<=1}" :style="{'background-color':settings.theme}"><img alt="loading"
                                                                                                     height="24"
                                                                                                     v-show="screen===0"
                                                                                                     class="whitify"
                                                                                                     src="/img/loading_spinner.gif">
            {{ btnStart }}
          </button>
        </section>
      </transition>
      <transition name="fade">
        <section v-if="screen===2" class="category special-scroll">
          <div :style="{'background-image': 'url('+(c.images[c.img])+')'}" :key="'c-'+k"
               class="category-item"
               :class="{disabled:c.state===2||(guest.voted && guest.voted[code] && guest.voted[code].categories && guest.voted[code].categories[c.id])}"
               @click="clickCategory(c)" v-for="(c,k) in categories.filter((cat)=> {return !!cat;})">
            <span
                v-if="!user && guest.voted && guest.voted[code] && guest.voted[code].categories && guest.voted[code].categories[c.id]"
                class="overlay overlay-dark overlay-like"><img class="center-all"
                                                               alt="Checkmark" height="60"
                                                               src="/img/v.png"></span>
          </div>
        </section>
      </transition>
      <transition name="slide-fade">
        <section v-if="screen===3 && category" class="vote special-scroll">
          <div class="category">
            <div class="category-item" :style="{'background-image': 'url('+(category.images[category.img])+')'}">
              <span class="back-text" @click="back(categories.length>1 ? 2: 1)">{{ trans('back') }}</span>
            </div>
          </div>
          <div class="clue">
            <input @change="saveCategories" :disabled="!allowEdit" v-model="category.clue"
                   class="hidden-input">
          </div>
          <div class="players">
            <div v-if="category.state===1" class="players-selected-container">
              <span class="players-selected-label" v-show="!allowEdit">{{ trans('my_selection') }}</span>
              <div class="players-selected" v-show="!allowEdit">
                <span :key="'selected-'+k" :style="{'background-image': 'url('+getPlayer(pid).img+')'}"
                      @click="playerNavigateTo=[k, false]" v-for="(pid,k) in selectedPlayers"
                      class="player-selected"></span>
                <span :key="'empty-'+x" class="" v-for="(x,k) in (settings.maxPlayers-selectedPlayers.length)">{{
                    k + 1 + selectedPlayers.length
                  }}</span>
              </div>
            </div>
            <!-- https://github.com/SSENSE/vue-carousel -->
            <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :paginationEnabled="false"
                      :class="{'hide-nav':showSearchModal||showModal||showCategoryModal}"
                      :autoplayTimeout="3000" :loop="true"
                      :navigationEnabled="true" :navigationClickTargetSize="8"
                      playerNavigateTo="playerNavigateTo"
                      :navigationNextLabel="'›'"
                      :navigationPrevLabel="'‹'">
              <slide :key="'p-'+k" v-for="(p,k) in categoryPlayers">
                <div :style="{'background-image': 'url('+p.img+')'}"
                     class="players-item"
                     @click="clickPlayer(p)">
                  <div v-show="p.name && !p.hideName" class="player-name"
                       :style="{'background-image':(settings.theme?'':`url(assets/img/player-bg.jpg)`)}">
                    <span>{{ p.name }}</span>
                    <span v-show="p.details">{{ p.details }}</span>
                  </div>
                  <span class="overlay" :class="{boomerang:p.img2}"
                        :style="{'background-image':p.img2?('url('+p.img2+')'):''}"></span>
                  <span v-show="selectedPlayers.includes(p.id)" class="overlay overlay-dark overlay-like"><img
                      alt="Checkmark" height="60" class="center-all"
                      src="/img/v.png"></span>
                </div>
              </slide>
            </carousel>
          </div>
          <div v-show="allowEdit || category.state===1"
               :class="{'disabled': !allowEdit && !allowSendVote }" :style="{'background-color':settings.theme}"
               class="btn-vote" @click="clickSubmit">
            {{ allowEdit ? trans('btn_player_edit') : allowSendVote ? trans('btn_submit') : trans('btn_choose') }}
          </div>
        </section>
      </transition>
      <transition name="slide-fade">
        <section v-if="screen>3 && guest" class="approval"
                 :style="{'background-image':'url('+settings.background+')', 'background-color':settings.theme}">
          <div class="overlay overlay-dark p-3">
            <div class="row">
              <div class="col-1"></div>
              <div class="col-10">
                <h2 class="text-center mt-4">הצבעה תתאפשר לאחר אימות טלפוני</h2>
                <div :class="{disabled:guest.approval!==0}">
                  <label for="name" class="text-right mt-3">שם מלא</label>
                  <input id="name" class="tel text-center" v-model="guest.name">
                  <p class="name-error" v-show="guest.name.length && guest.name.length<3"><small>*השתמשו בבקשה בשמכם
                    המלא</small></p>
                  <label for="tel" class="text-right mt-2">מספר טלפון</label>
                  <input id="tel" class="tel mb-3 text-center" v-model="guest.tel">
                </div>
                <label class="text-right mt-2" v-show="guest.approval===1">קוד</label>
                <div class="text-right mb-3">
                  <PincodeInput v-show="guest.approval===1"
                                v-model="guest.code" :length="6"
                                placeholder=""/>
                </div>
                <button
                    :disabled="!guest.name || guest.name.length <3 || !guest.tel || guest.tel.length!==10 || isApproving"
                    :class="{disabled:guest.approval!==0}"
                    class="btn btn-success btn-block btn-lg" style="direction: rtl"
                    @click="approveVote">{{ isApproving ? 'שולח SMS עם קוד...' : 'שלחו קישור להצבעה' }}
                </button>
                <p class="text-under my-2">שימוש רק לצורך שליחת לינק ולא ישמר לאחר מכן.</p>
                <transition name="slide-fade">
                  <button v-show="guest.approval===1"
                          class="btn btn-danger btn-block btn-lg mt-3"
                          @click="approveVoteDecline">איפוס פרטים
                  </button>
                </transition>
                <h6 class="text-justify text-white mt-3" style="direction: rtl" v-show="guest.approval!==1">
                  כדי לשמור על הוגנות התחרות, אנחנו מאפשרים לכל אחד ואחת להצביע פעם אחת. פייר, לא? בשביל זה נצטרך את
                  מספר הטלפון שלך, שישמש רק לצורך שליחת הלינק להצבעה ולא יישמר לאחר מכן
                </h6>
              </div>
            </div>
          </div>
        </section>
      </transition>
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import PincodeInput from 'vue-pincode-input';
import $ from "jquery/dist/jquery.min";
import Sidebar from "./components/SideBar";
import EditModal from "./components/EditModal";
import GuestsModal from "./components/GuestsModal";
import CategoryEditModal from "./components/CategoryEditModal";
import SearchModal from "./components/SearchModal";

const timer = {votes: null, settings: null};
const catStates = {closed: 0, open: 1, finished: 2};
export default {
  name: 'app',
  props: ['code', 'accessToken'],
  components: {Sidebar, EditModal, GuestsModal, AvatarCropper, CategoryEditModal, SearchModal, PincodeInput},
  data() {
    return {
      publicPath: process.env.BASE_URL,
      allowEdit: false,
      category: null,
      categories: [],
      guest: {
        approval: 0,
        categories: {},
        code: '',
        name: '',
        message: false,
        group_num: null,
        id: null,
        tel: '',
        voted: {},
      },
      guests: [],
      id: null,
      imgQuality: 0.99,
      isSidebarOpen: false,
      isApproving: false,
      isResultsOnly: false,
      leadingCandidate: null,
      locals: {
        "approve": {he: "אישור", en: "Approve"},
        "back": {he: "חזרה", en: "Back"},
        "cancel": {he: "ביטול", en: "Cancel"},
        "close": {he: "סגור", en: "Close"},
        "correct": {he: "צדקו", en: "Correct"},
        "btn_choose": {he: "לחצו על התמונה לבחירה", en: "Click on the image to select"},
        "btn_player_edit": {he: "הוספת מתמודד", en: "Add a candidate"},
        "btn_start": {he: "להצבעה לחצו כאן", en: "Press here to start"},
        "btn_submit": {he: "שלחו", en: "Send"},
        "btn_voted": {he: "הצבעה שלכם כבר נקלטה", en: "You have already voted"},
        "btn_wait": {he: "ההצבעה סגורה", en: "Voting hasn't started yet"},
        "btn_add_category": {he: "קטגוריה חדשה", en: "Add a category"},
        "language": {he: "שפה", en: "Language"},
        "leaders": {he: "מצביעים מובילים", en: "Leading players"},
        "logout": {he: "התנתק", en: "Logout"},
        "reset": {he: "איפוס", en: "Reset"},
        "save": {he: "שמור", en: "Save"},
        "message": {he: "הודעת פופאפ למשתתפים", en: "A popup message for users"},
        "my_selection": {he: "הבחירות שלי", en: "My selection"},
        "signedPlayers": {he: "נרשמו", en: "Registered"},
        "support": {he: "תמיכה בוואטסאפ", en: "Support on WhatsApp"},
        "theme": {he: "צבע ערכת נושא", en: "Theme Color"},
        "voted": {he: "הצביעו", en: "Voters"},
        "wrong": {he: "טעו", en: "Wrong"}
      },
      players: [],
      playerEdited: null,
      playerNavigateTo: [0, false],
      screen: 1,
      selectedPlayers: [],
      settings: {
        he: true,
      },
      locked: 0,
      showLeaders: false,
      showLeadingCandidates: false,
      showModal: false,
      showCategoryModal: false,
      showGuestsModal: false,
      showSearchModal: false,
      sideBarRender: 0,
      tvMode: false,
      user: null,
      votesCategory: [],
      myVotesList: [],
    }
  },
  methods: {
    editCategory(category) {
      this.category = category;
      this.showCategoryModal = true;
    },
    selectCategory(category) {
      this.category = category;
      this.getVotesSent();
    },
    addCategory() {
      this.settings.categories = Number(this.settings.categories) + 1;
      if (!this.categories) this.categories = [];
      this.category = {
        id: this.settings.categories,
        name: 'קטגוריה חדשה',
        img: 'main',
        images: {
          main: "img/category-add.png",
          sill: "img/category-add.png",
          show: "img/category-add.png"
        },
        clue: "רמז 1",
        state: 0,
        players: [],
        playerId: 0,
      }
      this.categories.push(this.category);
      this.showCategoryModal = true;
      this.saveCategories(true);
      this.saveSettings();
    },
    addExistingPlayer(p) {
      this.showSearchModal = false;
      if (!this.category.players.includes(p.id)) {
        this.category.players.push(p.id);
        this.saveCategories();
      }
    },
    addPlayer() {
      this.showSearchModal = false;
      this.settings.players = Number(this.settings.players) + 1;
      if (!this.players || !Array.isArray(this.players) || this.players.length === 0) this.players = [];
      this.players.push({
        id: this.settings.players,
        name: '',
        img: '',
        img2: '',
        details: '',
        group: null,
      });
      //open for edit
      this.playerEdited = this.players[this.players.length - 1];
      this.category.players.push(this.playerEdited.id);
      this.saveCategories();
      this.showModal = true;
      this.saveSettings();
    },
    approveVote() {
      if (!this.settings.allowVote) return;
      this.isApproving = true;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          id: this.id,
          name: this.guest.name,
          tel: this.guest.tel,
          title: this.settings.title
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'approveVote');
        },
        success: function (response) {
          if (response.status) {
            self.$dialog.alert('קוד נשלח אליך ב- SMS, נא להקליד את הקוד.');
            self.guest.id = response.id;
            self.guest.approval = 1;

            self.storeGuest();
          } else if (response.message) {
            self.$dialog.alert(response.message);
          } else {
            self.$dialog.alert('סליחה, ניתן להצביע רק פעם אחת! :)');
          }
          self.isApproving = false;
        },
        dataType: 'json'
      });
    },
    validateAccessToken() {
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          code: this.code,
          accessToken: this.accessToken
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'validateAccessToken');
        },
        success: (response) => {
          if (response.status && response.valid) {
            this.isResultsOnly = true;
            this.tvMode = true;
          }
        },
        dataType: 'json'
      });
    },
    openGuests() {
      if (!this.user) return;
      this.showGuestsModal = true;
    },
    closeGuestsModal() {
      this.showGuestsModal = false;
    },
    getSignedPlayers() {
      if (!this.user) return;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {id: this.id},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'getVotePlayers');
        },
        success: function (response) {
          if (!response.error) {
            self.guests = response;
          }
        },
        dataType: 'json'
      });
    },
    checkCode() {
      if (!this.guest.code || this.guest.code.length !== 6) return;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          id: this.id,
          tel: this.guest.tel,
          code: this.guest.code
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'checkCode');
        },
        success: function (response) {
          if (response.status) {
            self.guest.approval = 2;
            self.guest.voted = response.votes;
            self.guest.group_num = response.guest.group_num;
            self.storeGuest();

            if (self.categories.length === 1) {
              self.category = self.categories[0];
              self.screen = 3;
            } else {
              self.screen = 2;
            }
          } else {
            self.guest.code = '';
          }
        },
        dataType: 'json'
      });
    },
    checkCodeTest() {
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          id: this.id,
          tel: this.guest.tel,
          code: '189408'
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'checkCode');
        },
        success: function (response) {
          //    console.log(response);
        },
        dataType: 'json'
      });
    },
    approveVoteDecline() {
      this.guest.name = '';
      this.guest.tel = null;
      this.guest.approval = 0;
      this.guest.code = '';
    },
    back(to) {
      if (to === 2 || to === 1) {
        this.category = null;
        this.screen = to;
      }
    },
    clickCategory(category) {
      //  console.log(category);
      this.selectedPlayers = [];
      this.category = category;
      this.screen = 3;
      this.storeGuest();
    },
    clickPlayer(player) {
      // console.log(player);
      if (!this.allowEdit) {
        this.selectPlayer(player.id);
      } else if (player.id) {
        this.editPlayer(player);
      } else {
        this.addPlayer();
      }
      if (timer.return) {
        clearTimeout(timer.return);
        timer.return = null;
      }
    },
    clickSubmit() {
      if (this.allowEdit) {
        this.showSearchModal = true;
      } else this.submitSelected();
    },
    createNew() {
      let self = this;
      let url = "https://ivote.tv/api/" + (this.user ? ("?userId=" + this.user.id) : '');
      $.ajax({
        url: url,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'createVote');
        },
        success: function (response) {
          if (response.status) {
            window.location.href = 'https://ivote.tv/v/' + response.code
          } else {
            self.openAlert(JSON.stringify(response));
          }
        },
        dataType: 'json'
      });
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      if (!this.user) {
        if (timer.settings) clearInterval(timer.settings)
        timer.settings = setInterval(this.getVote, 10000);
      }
    },
    deleteVote() {
      let url = "https://ivote.tv/api/";
      let self = this;
      this.$dialog.confirm('למחוק את האורע לצמניתות?')
          .then(function () {
            $.ajax({
              url: url,
              data: {id: self.id},
              type: "POST",
              beforeSend: function (xhr) {
                xhr.setRequestHeader('Action', 'deleteVote');
              },
              success: function () {
                self.code = 'BE51';
                self.getVote();
                self.getMyVotes();
              },
              dataType: 'json'
            });
          })
          .catch(function () {
            console.log('Clicked on cancel');
          });
    },
    editPlayer(player) {
      this.playerEdited = player;
      this.showModal = true;
    },
    getMyVotes() {
      if (!this.user) return;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {userId: this.user.id},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'getMyVotes');
        },
        success: function (response) {
          if (response) {
            self.myVotesList = response.map(function (v) {
              try {
                v.settings = JSON.parse(v.settings);
              } catch (e) {
                v.settings = {};
              }
              return v;
            });
            self.sideBarRender++;
          }
        },
        dataType: 'json'
      });
    },
    getPlayer(id) {
      for (let i = 0; i < this.players.length; i++)
        if (Number(id) === Number(this.players[i].id))
          return this.players[i];
      return null;
    },
    getQR() {
      $.ajax({
        url: "https://www.quizygame.com/php/qrRequest.php",
        data: {code: this.code},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'getQR');
        },
        success: function (response) {
          // console.log(response);
        },
        dataType: 'json'
      });
    },
    getVote() {
      if (this.selectedPlayers.length || this.screen === 3) return;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {code: this.code},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'getVote');
        },
        success: function (response) {
          if (Number(response.approved)) {

            self.id = Number(response.id);
            let settings = JSON.parse(response.settings);
            settings.showScore = typeof settings.showScore === 'undefined' ? false : (settings.showScore === true || settings.showScore === 'true');
            settings.allowVote = typeof settings.allowVote === 'undefined' ? false : (settings.allowVote === true || settings.allowVote === 'true');
            settings.smsVote = typeof settings.smsVote === 'undefined' ? false : (settings.smsVote === true || settings.smsVote === 'true');
            settings.minPlayers = typeof settings.minPlayers === 'undefined' ? 1 : Number(settings.minPlayers);
            settings.maxPlayers = typeof settings.maxPlayers === 'undefined' ? 3 : Number(settings.maxPlayers);
            settings.resetTimer = typeof settings.resetTimer === 'undefined' ? false : settings.resetTimer === 'true';
            settings.hideTitles = typeof settings.hideTitles === 'undefined' ? false : settings.hideTitles === 'true';
            settings.startButton = typeof settings.startButton === 'undefined' ? true : settings.startButton === 'true';
            settings.message = typeof settings.message === 'undefined' ? null : settings.message;
            settings.theme = typeof settings.theme === 'undefined' ? "#7000A0" : settings.theme;
            settings.he = typeof settings.he === 'undefined' ? true : settings.he === 'true';
            self.settings = settings;

            if (response.categories) {
              let categories = JSON.parse(response.categories);
              if (!categories) self.categories = [];
              else {
                categories = categories.map(c => {
                  if (typeof c.players === 'undefined')
                    c.players = [];
                  c.playerId = Number(c.playerId);
                  c.state = Number(c.state);
                  return c;
                })
                self.categories = categories;

                if (self.tvMode || self.user) {
                  self.selectCategory(self.categories[0]);
                  self.getVotesSent();
                }
              }
            }

            if (response.players) {
              let players = JSON.parse(response.players);
              if (!players || !Array.isArray(players)) self.players = [];
              else self.players = players;
            }

            self.showModal = false;
            if (self.user && location.href.includes('localhost:8080')) {
              self.allowEdit = true;
            } else {
              self.allowEdit = typeof response.allowEdit === 'undefined' ? false : (response.allowEdit === true || response.allowEdit === 'true');
            }

            if (response.accessToken) {
              self.accessToken = response.accessToken;
            }
            self.sideBarRender++;
          } else {
            location.href = "/";
          }
        },
        dataType: 'json'
      });
    },
    getVotesSent() {
      if (!this.id) return;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {id: this.id},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'getVotesSent');
        },
        success: function (response) {
          if (typeof response === 'object') {
            self.votesCategory = response.map(v => {
              v.votes = JSON.parse(v.votes);
              return v;
            }).filter(v => Number(v.category) === Number(self.category.id));
            // self.sideBarRender++;
          }
        },
        dataType: 'json'
      });
    },
    handleUploadedLogo(resp) {
      if (resp.status) {
        this.settings.logo = resp.url;
        this.saveSettings();
      }
    },
    openLeadersBoard(wide) {
      this.showLeaders = true;
    },
    logout() {
      document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.user = null;
      this.myVotesList = [];
      this.allowEdit = false;
      document.location.reload();
    },
    openAlert(txt) {
      this.$dialog.alert(txt);
    },
    openFullscreen() {
      let el = document.documentElement;// document.getElementById('app');
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) { /* Firefox */
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        el.webkitRequestFullscreen();
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
      }
    },
    pingUser() {
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {userId: this.user.id},
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'pingUser');
        },
        success: function (response) {
          if (!response.status && !location.href.includes("localhost:8080")) {
            self.user = null;
          } else {
            self.getVotesSent();
            if (timer.votes) clearInterval(timer.votes);
            timer.votes = setInterval(self.getVotesSent, 10000);

            self.getSignedPlayers();
            if (timer.guests) clearInterval(timer.guests);
            timer.guests = setInterval(self.getSignedPlayers, 10000);
          }
        },
        dataType: 'json'
      });
    },
    resetVotes() {
      let url = "https://ivote.tv/api/";
      let self = this;
      this.$dialog.confirm('לאפס את כל ההצבעות?')
          .then(function () {
            $.ajax({
              url: url,
              data: {id: self.id},
              type: "POST",
              beforeSend: function (xhr) {
                xhr.setRequestHeader('Action', 'resetVotes');
              },
              success: function () {
                self.getVotesSent();
              },
              dataType: 'json'
            });
          })
          .catch(function () {
          });
    },
    removeCategory() {
      let self = this;
      this.categories = this.categories.filter(c => c.id !== self.category.id);
      if (!this.categories) this.categories = [];
      this.saveCategories();
    },
    removePlayer() {
      let self = this;
      this.categories = this.categories.map((c) => {
        c.players = c.players.filter(p => p.id !== self.playerEdited.id)
        return c;
      });
      this.saveCategories();
      this.players = this.players.filter(p => p.id !== self.playerEdited.id);
      self.showModal = false;
      this.savePlayer();
    },
    saveCategories(keepModal) {
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          id: this.id,
          categories: this.categories
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'setVoteCategories');
        },
        success: function () {
          if (!keepModal)
            self.showCategoryModal = false;
        },
        dataType: 'json'
      });
    },
    savePlayer(keepModal) {
      let self = this;
      let players = this.players.map(p => {
        delete p.score;
        return p;
      });

      if (Array.isArray(players)) {
        $.ajax({
          url: "https://ivote.tv/api/",
          data: {
            id: this.id,
            players: players
          },
          type: "POST",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Action', 'setVotePlayers');
          },
          success: function (response) {
            if (response.error) {
              self.$dialog.alert(response.error);
            } else if (!response.status) {
              self.$dialog.alert("ארעה תקלה, המועמד לא נשמר");
            }
            if (!keepModal)
              self.showModal = false;
          },
          dataType: 'json'
        });
      }
    },
    saveSettings(showModal) {
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {id: this.id, settings: this.settings},
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'setVote');
        },
        success: function () {
          if (showModal)
            self.$dialog.alert('הגדרות נשמרו.');
        },
        dataType: 'json'
      });
    },
    selectPlayer(id) {
      if (!this.players || this.category.state !== 1) return;
      for (let i = 0; i < this.selectedPlayers.length; i++) {
        if (this.selectedPlayers[i] === id) {
          this.selectedPlayers.splice(i, 1);
          return;
        }
      }
      if (this.selectedPlayers.length < this.settings.maxPlayers)
        this.selectedPlayers.push(id);
    },
    start() {
      if ((this.settings.allowVote && (!this.settings.smsVote || this.guest && this.guest.approval === 2)) || this.allowEdit) {
        if (this.categories.length === 1) {
          this.category = this.categories[0];
          this.screen = 3;
        } else {
          this.screen = 2;
        }
        if (this.settings.message && !this.guest.message) {
          this.guest.message = true;
          this.$dialog.alert(this.settings.message);
        }
        let self = this;
        if (!this.user) {
          if (this.settings.resetTimer)
            timer.return = setTimeout(function () {
              self.screen = 1;
            }, 10000);
          window.addEventListener("scroll", function () {
            clearTimeout(timer.return);
            timer.return = null;
          });
        }
        // this.openFullscreen();
      } else if (this.settings.smsVote && this.settings.allowVote) {
        //pass sms verification
        this.screen = 4;
      }
    },
    storeGuest() {
      let guest = {...this.guest};
      if (!guest.voted[this.code]) guest.voted[this.code] = {};
      guest.voted[this.code].approval = this.guest.approval;
      guest.voted[this.code].code = this.guest.code;
      guest.code = '';
      guest.approval = 0;
      localStorage.setItem('guest', JSON.stringify(guest));
    },
    submitSelected() {
      if (!this.allowSendVote || !this.settings.allowVote || this.category.state !== 1) return;
      //send results
      this.screen = 0;
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: {
          id: this.id,
          votes: this.selectedPlayers,
          category: this.category.id,
          guestId: this.guest.id
        },
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'submitVote');
        },
        success: function (response) {
          if (response.status) {

            if (self.guest.voted[self.code]) {
              if (!self.guest.voted[self.code].categories || self.guest.voted[self.code].categories instanceof Array)
                self.guest.voted[self.code].categories = {};
              self.guest.voted[self.code].categories[self.category.id] = self.selectedPlayers;
            }

            if (self.settings.smsVote) {
              self.storeGuest();
              self.screen = 2;
              setTimeout(() => self.screen = 1, 5000);
            } else {
              self.screen = 0;
              setTimeout(() => self.screen = 1, 5000);
            }
            self.$dialog.alert('תודה, ההצבעה נקלטה. :)');
          } else {
            self.$dialog.alert('מצטערים, יתכן שכבר הצבעתם. :(');
          }
          self.selectedPlayers = [];
        },
        dataType: 'json'
      });
    },
    trans(key) {
      if (!this.locals[key]) return key;
      return this.locals[key][this.settings.he ? 'he' : 'en'];
    },
    updateTvMode(e) {
      this.tvMode = e.value;
    },
    toggleShowScore() {
      //if user
      if (!this.isSidebarOpen && (this.user || this.isResultsOnly)) {
        this.settings.showScore = !this.settings.showScore;
        this.sideBarRender++;
      }
    },
    updateHe(e) {
      this.settings.he = e.value;
    }
  },
  mounted: function () {
    if (localStorage.getItem('user')) {
      try {
        this.user = JSON.parse(localStorage.getItem('user'));
        //  console.log("Welcome user", this.user);
        this.pingUser();
      } catch (e) {
        console.log(e);
      }
    }

    if (localStorage.getItem('guest')) {
      try {
        let guest = JSON.parse(localStorage.getItem('guest'));
        if (!guest.name) guest.name = '';
        if (!guest.code) guest.code = '';
        if (!guest.tel) guest.tel = '';
        if (!guest.group_num) guest.group_num = null;
        if (!guest.approval) guest.approval = 0;
        if (!guest.voted) guest.voted = {};
        if (guest.voted[this.code]) {
          guest.approval = guest.voted[this.code].approval ? guest.voted[this.code].approval : 0;
          guest.code = guest.voted[this.code].code ? guest.voted[this.code].code : '';
          if (!guest.voted[this.code].categories || guest.voted[this.code].categories instanceof Array)
            guest.voted[this.code].categories = {};
        }
        this.guest = guest;
        // console.log("Welcome guest", guest);
      } catch (e) {
        console.log(e);
      }
    }

    this.getVote();

    if (!this.user) {
      if (timer.settings) clearInterval(timer.settings)
      timer.settings = setInterval(this.getVote, 10000);
    }

    let self = this;
    document.addEventListener("keydown", function (e) {

      if (e.code === 'KeyR') {
        self.toggleShowScore();
      }

      if (self.tvMode) {
        if (e.code === "Escape") {
          self.leadingCandidate = null;
          self.showLeaders = false;
          self.showLeadingCandidates = false;
        } else if (e.code.includes("Digit")) {
          let digit = Number(e.code.replace("Digit", ""));
          if (digit > 0 && digit <= 9) {
            self.leadingCandidate = digit;
            self.showLeaders = false;
            self.showLeadingCandidates = true;
          }
        } else if (e.code === "ArrowRight") {
          if (self.showLeadingCandidates && self.leadingCandidate < self.topPlayers.length) {
            self.leadingCandidate = Number(self.leadingCandidate) + 1;
          }
        } else if (e.code === "ArrowLeft") {
          if (self.showLeadingCandidates && self.leadingCandidate > 1) {
            self.leadingCandidate = Number(self.leadingCandidate) - 1;
          }
        }
      }
    });

    //prevent back button
    window.onpopstate = event => {
      if (this.screen === 2)
        this.screen = 1;
      else if (this.screen === 3) {
        this.screen = 2;
      }
    };

    //check accessToken
    if (this.accessToken) this.validateAccessToken();
  },
  computed: {
    showHeader() {
      return !(window.innerWidth < window.innerHeight && this.screen === 3);
    },
    allowSendVote() {
      return this.category.state === 1 && this.selectedPlayers.length <= this.settings.maxPlayers && this.selectedPlayers.length >= this.settings.minPlayers;
    },
    btnStart() {
      return this.settings && this.settings.allowVote ? this.trans('btn_start') : this.trans('btn_wait');
    },
    leader() {
      if (this.leadingCandidate > 0 && this.leadingCandidate <= this.topPlayers.length) {
        return this.topPlayers[this.leadingCandidate - 1];
      } else {
        return null;
      }
    },
    categoryPlayers() {
      let players = [];
      if (this.category) {
        players = this.players.filter((p) => {
          return this.category.players.includes(p.id) && (!this.guest.group_num || !p.group || Number(this.guest.group_num) !== Number(p.group));
        })
        if (players.length === 0)
          players.push({
            "id": 0,
            "name": "מועמד לדוגמה",
            "hideName": false,
            "img": "/img/player.png",
          })
      }
      return players;
    },
    votesCurrCategoryPile() {
      let arrVotes = [];
      let objFavs = {};
      this.votesCategory.forEach(v => {
        arrVotes = arrVotes.concat(v.votes);
        if (v.group_name) {
          if (typeof objFavs[v.group_name] == 'undefined') objFavs[v.group_name] = [];
          objFavs[v.group_name] = objFavs[v.group_name].concat(v.votes);
        }
      });
      return {arrVotes: arrVotes, objFavs: objFavs};
    },
    votesCurrCategoryCorrect() {
      let corr = this.votesCategory.filter(v => v.votes.includes(this.category.playerId + "")).length;
      return Math.round(corr * 100 / this.votesCategory.length);
    },
    votesCurrCategoryWrong() {
      let corr = this.votesCategory.filter(v => !v.votes.includes(this.category.playerId + "")).length;
      return Math.round(corr * 100 / this.votesCategory.length);
    },
    leadersList() {
      let list = this.votesCategory.filter(v => v.votes.includes(this.category.playerId + ""));
      list.sort((a, b) => {
        return a.create_date < b.create_date ? -1 : 1;
      });
      return list.slice(0, 5);
    },
    scoredPlayers() {
      if (!this.categoryPlayers) return [];
      return this.categoryPlayers.map(p => {
        p.score = 0;
        p.fav = [];
        this.votesCurrCategoryPile.arrVotes.forEach(function (v) {
          if (Number(p.id) === Number(v)) p.score++;
        });

        //  console.log(this.votesCurrCategoryPile.objFavs)
        Object.keys(this.votesCurrCategoryPile.objFavs).forEach(f => {
          let arr = this.votesCurrCategoryPile.objFavs[f].map((x) => x);
          if (Number(arr.sort((a, b) =>
              arr.filter(v => v === a).length
              - arr.filter(v => v === b).length
          ).pop()) === Number(p.id)) p.fav.push(f);
        })

        return p;
      });
    },
    showPlayers() {
      let players = this.players;
      for (let i = 0; i < players.length % 3; i++) players.push({
        id: -1 * (i + 1),
        name: '',
        img: this.settings.logo
      });
      return players;
    },
    sortedPlayers() {
      //if there are any votes
      if (this.votesCurrCategoryPile.arrVotes.length) {
        return [...this.scoredPlayers].sort((a, b) => {
          return a.score > b.score ? -1 : 1;
        });
      } else {
        //no votes - show latest players added
        return [...this.categoryPlayers].reverse();
      }
    },
    topPlayers() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.sortedPlayers.splice(0, this.settings.rows * this.settings.cols);
    },
  },
  watch: {
    user: function (n) {
      if (n && n.id > 0) {
        this.getMyVotes();
      }
    },
    "guest.code": function (n) {
      if (n && n.length === 6)
        this.checkCode();
    },
    isSidebarOpen(n) {
      if (n) {
        clearInterval(timer.settings);
      }
    },
    tvMode(m) {
      //  console.log(m)
    }
  },
}
</script>
<style lang="scss">
@font-face {
  font-family: "Assistant";
  src: url("assets/fonts/Assistant/Assistant-Regular.ttf");
  font-weight: normal;
}

@font-face {
  font-family: "Assistant";
  src: url("assets/fonts/Assistant/Assistant-Bold.ttf");
  font-weight: bold;
}

@font-face {
  font-family: "Assistant";
  src: url("assets/fonts/Assistant/Assistant-ExtraBold.ttf");
  font-weight: 800;
}

:root {
  --color-main: #018AFC;
  --color-black-trans: rgba(20, 20, 20, 0.66);
  --color-purple: #7000A0;
  --color-purple-trans: rgba(112, 0, 160, 0.5);
  --color-secondary: #fefefe;
  --color-green: #08C207;
  --color-red: #FC002F;
  --color-grey: #222;
  --color-dark: #101010;
  --color-white-trans: rgba(255, 255, 255, 0.3);
}

body {
  font-size: 16px;
  font-family: 'Assistant', sans-serif !important;
  background-color: var(--color-grey) !important;
}

h1, h2 {
  color: white;
  text-align: center;
  font-family: 'Assistant', sans-serif;
}

h1 {
  margin-top: 200px;
}

h2 {
  direction: rtl;
}

#app {
  overflow: hidden;
}

.header {
  width: 100%;
  left: 0;
  top: 0;
  background: var(--color-dark);
  padding: 2px 12px;
  font-size: 24px;
  box-shadow: 0 0 4px 1px var(--color-grey);
  z-index: 1;

  .header-logo {
    line-height: 1;
  }

  .header-menu {
    color: #3f3f3f;
    cursor: pointer;

    > span {
      margin-left: 15px;
    }
  }
}

.center-all {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.dg-content {
  font-size: 18px !important;
}

.dg-btn {
  color: #fff !important;
  background-color: var(--color-purple) !important;
  border-color: var(--color-purple-trans) !important;
}

.app-wrapper {
  background-color: var(--color-dark);

  section {
    position: relative;
    height: calc(100vh - 40px);

    @supports (-webkit-touch-callout: none) {
      height: calc(100vh - 60px);
    }

    @media (min-width: 768px) {
      max-width: calc((100vh - 80px) / 1.777);
      margin: auto;
      box-shadow: 0 0 10px 2px #000;
    }
  }

  .category {
    //background-color: var(--color-purple-trans);
  }

  .approval {
    position: relative;
    background: var(--color-purple) top/100% 90% no-repeat;

    h2, label {
      color: var(--color-secondary);
    }

    .tel, label {
      width: 100%;
      font-size: 1.75rem;
    }
  }
}

.header.hidden ~ .app-wrapper section {
  height: 100vh !important;
}

.welcome {
  padding: 0;
  text-align: center;
  color: var(--color-secondary);
  background: var(--color-purple);

  .container {
    padding: 60px 0;
    width: 100%;
    height: 80%;
    background: var(--color-purple) top/cover no-repeat;


    @media (max-width: 768px) {
      height: 83%;
    }

    &.no-start-button {
      height: 90%;
    }
  }

  .welcome-screen-btn {
    cursor: pointer;
    z-index: 1;
    position: absolute;
    background: transparent;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  .title {
    font-size: 72px;
    font-weight: bold;
    margin-bottom: 0;
    line-height: 120px;
  }

  .subtitle {
    font-size: 28px;
  }

  button.btn-start {
    position: relative;
    //bottom: calc(16% - 68px);
    left: 0;
    width: 100%;
    padding: 15px;
    font-size: 2rem;
    font-weight: bold;
    border-radius: 0;
    box-shadow: -1px 0 8px 1px #111;
    z-index: 2;

    @supports (-webkit-touch-callout: none) {
      bottom: 20px;
    }

    img {
      margin: 0 4px;
    }
  }

  .btn-start {
    background-color: var(--color-purple);
    color: var(--color-secondary);
    border: none;
    outline: none;

    &:hover, &:focus {
      color: whitesmoke;
    }
  }
}

.welcome-logo {
  display: block;
  margin: 30px auto;
  width: 50%;
  opacity: 0.75;
  height: auto;
}

.category {
  .category-item {
    width: 100%;
    height: 50vw;
    background: var(--color-black-trans) bottom center/cover no-repeat;
    cursor: pointer;
    position: relative;
    box-shadow: 0 -1px 6px 0 #000;
    @media (min-width: 768px) {
      height: calc((100vh - 100px) / 3.554);
    }
  }
}

.vote {

  background-color: var(--color-dark);

  .category {
    .category-item {
      height: 44vw;
      @media (min-width: 768px) {
        height: calc((100vh - 100px) / 3.554);
      }
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    width: 64px;
    height: auto;
    padding: 2px 12px 12px 2px;
    background-color: var(--color-black-trans);
    //color: var(--color-secondary);
    text-align: center;
    cursor: pointer;
    border-bottom-right-radius: 75%;
  }

  .back-text {
    position: absolute;
    left: 0;
    top: 0;
    width: 64px;
    height: auto;
    line-height: 1.2;
    font-weight: bold;
    background-color: var(--color-black-trans);
    color: var(--color-secondary);
    text-align: center;
    cursor: pointer;
    border-bottom-right-radius: 15px;
    padding: 6px 8px 10px 0;
  }

  .clue {
    background-color: var(--color-dark);
    box-shadow: 0 0 8px 2px var(--color-dark);
    text-align: center;
    position: relative;
    z-index: 9;

    input {
      width: 100%;
      padding: 2px 6px;
      display: block;
      text-align: center;
      margin: auto;
      font-size: 1.2rem;
      line-height: 36px;
      background-color: transparent;
      color: var(--color-secondary);
    }
  }

  .VueCarousel-navigation-button {

    color: var(--color-secondary) !important;
    font-size: 6rem;
    line-height: 6rem;
    transform: translateY(-50%) translateX(0) !important;
    outline: none !important;
  }

  .btn-vote {
    box-shadow: 0 -1px 8px 0px var(--color-dark);
    width: 100%;
    padding: 15px;
    text-align: center;
    font-size: 1.75rem;
    color: var(--color-secondary);
    background: var(--color-purple);
    z-index: 10;
    position: relative;
    font-weight: bold;
    cursor: pointer;
  }

  .players {
    position: relative;
    width: 100%;
    @media (min-width: 768px) {
      height: calc((100vh - 80px) / 1.777);
    }

    .players-item {
      height: 100vw;
      width: 100vw;
      background: var(--color-black-trans) center/cover no-repeat;
      cursor: pointer;

      @media (min-width: 768px) {
        height: calc((100vh - 80px) / 1.777);
        width: calc((100vh - 80px) / 1.777);
      }
    }

    .players-selected-container {

      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      border-bottom-right-radius: 20px;
      background-color: var(--color-black-trans);
      padding: 4px 8px 8px 0;

      .players-selected-label {
        display: block;
        text-align: center;
        position: relative;
        font-size: 16px;
        margin-left: 8px;
        line-height: 1.2;
        font-weight: bold;
        color: white;
      }

      .players-selected {
        display: flex;
        position: relative;
        z-index: 1;
        margin-top: 4px;

        span {
          cursor: pointer;
          border-radius: 100%;
          width: 2rem;
          height: 2rem;
          margin-left: 8px;
          color: white;
          overflow: hidden;
          text-align: center;
          line-height: 1.8rem;
          display: inline-block;
          border: 2px solid white;
          background-color: var(--color-black-trans);
          background-size: cover;
        }
      }

    }

  }
}

.flex-apart {
  display: flex;
  justify-content: space-between;
}

.flex-center-v {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.flex-start {
  display: flex;
  justify-content: flex-end;
}

.flex-start > * {
  margin-left: 10px;
}

.players-tv {
  display: grid;
  width: 100%;
  overflow: hidden;
  height: calc(100vh - 62px);
  background: #101010;

  @media (max-width: 768px) {
    overflow-y: auto;
    grid-template-columns: repeat(2, 50%) !important;
    grid-template-rows: auto !important;
  }

  .players-item {

    .player-score {
      background: var(--color-black-trans);
      color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      width: 72px;
      height: auto;
      text-align: center;
      z-index: 20;
      font-size: 32px;
      line-height: 48px;
      letter-spacing: -1px;

      &::before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: 0;
        bottom: -36px;
        border-style: solid;
        border-width: 36px 72px 0 0;
        border-color: var(--color-black-trans) transparent transparent transparent;
      }
    }

    .player-name {
      position: absolute;
      bottom: 0;
      left: 92px;
      right: 0;
      padding-right: 10px;
      text-align: right;
      color: white;
      line-height: 48px;
      height: auto;
      background: var(--color-black-trans) center/cover no-repeat;
      z-index: 2;
      overflow: visible;
      font-size: 1.35rem;
      overflow-wrap: break-word;

      &::before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: -72px;
        bottom: 0;
        border-style: solid;
        border-width: 48px 72px 0 0;
        border-color: transparent var(--color-black-trans) transparent transparent;
      }
    }

    .fav-container {

      display: flex;
      flex-direction: column;
      float: right;
      padding: 0 10px 0 0;
      width: 50%;

      .fav-group {
        background-color: rgba(50, 50, 50, 0.75);
        color: white;
        width: 100%;
        float: right;
        margin-top: 10px;
        border-radius: 300px;
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-around;
      }
    }


  }
}

.players:not(.players-tv) {

  .players-item {

    .player-name {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 2px 20px 4px;
      text-align: right;
      color: white;
      height: auto;
      box-shadow: 0 -1px 6px 0 var(--color-dark);
      background: var(--color-black-trans) center/cover no-repeat;
      z-index: 2;
      overflow: visible;
      opacity: 0.8;

      span:first-child {
        font-size: 32px;
        font-weight: 600;
        line-height: 1.1;
      }

      span:last-child {
        font-size: 16px;
        font-weight: 400;
        line-height: 2;
      }

      span {

        display: block;
      }
    }
  }
}

.leaders-modal {
  position: absolute;
  left: calc(50% + 210px);
  top: 50%;
  min-width: 720px;
  transform: translate(calc(-50% - 420px), -50%);
  background: var(--color-purple) center/cover url("assets/img/player-bg.jpg") no-repeat;
  z-index: 999;
  padding: 10px;
  box-shadow: 5px 5px 10px 5px #111;

  .leaders-modal-right {

    .leaders-list {
      label {
        display: flex;
        text-align: right;
        direction: rtl;
        color: #E2D7A4;
        font-size: 26px;
        padding: 2px 16px;
        margin-right: -15px;
        font-weight: 500;
        line-height: 36px;
        background: var(--color-black-trans);

        strong {
          margin-left: 15px;
          font-size: 28px;

        }

        &:nth-child(1) {
          min-width: 100%;
        }

        &:nth-child(2) {
          min-width: 95%;
        }

        &:nth-child(3) {
          min-width: 90%;
        }

        &:nth-child(4) {
          min-width: 85%;
        }

        &:nth-child(5) {
          min-width: 80%;
        }
      }
    }

    .leaders-footer {
      position: absolute;
      bottom: 0;
      right: 15px;
      color: #E2D7A4;
      font-size: 24px;
      line-height: 1.5;
      font-weight: 400;
      margin: 0;
      display: flex;

      .leaders-category {
        margin: 0;
        padding: 2px 25px;
        background-image: linear-gradient(to top, #9B37BD, #4E1C5F);
      }

      .leaders-voters {
        margin: 6px 15px 0 0;
        color: #fff;

        span:first-child {
          background: var(--color-purple);
        }

        span:last-child {
          background: var(--color-black-trans);
        }

        span {
          padding: 1px 16px;
        }
      }
    }
  }

  .players-item {
    position: relative;
    margin-top: 8px;

    img {
      width: 100%;
      height: auto;
    }

    .player-name {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 10px;
      text-align: right;
      color: white;
      height: auto;
      box-shadow: 0 -1px 6px 0 var(--color-dark);
      background: var(--color-black-trans) center/cover no-repeat;
      z-index: 2;
      overflow: visible;
      opacity: 0.8;

      span:first-child {
        font-size: 24px;
        font-weight: 500;
        line-height: 1;
      }

      span:last-child {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8;
      }

      span {
        display: block;
      }
    }
  }
}

.leading-candidates-modal {
  position: absolute;
  left: 50%;
  top: 50%;
  min-width: 420px;
  max-width: 90vw;
  transform: translate(-50%, -50%);
  background: var(--color-purple) center/cover url("assets/img/player-bg.jpg") no-repeat;
  z-index: 999;
  padding: 4px;
  box-shadow: 5px 5px 10px 5px #111;

  .players-item {
    position: relative;
  }

  .player-score {
    position: absolute;
    left: 0.4rem;
    bottom: 1rem;
    font-size: 3rem;
    width: 5rem;
    height: 5rem;
    line-height: 1.2;
    border: none;
    text-align: center;
    border-radius: 100%;
    padding: 0;
    background: var(--color-purple) center/cover url("assets/img/player-bg.jpg") no-repeat;
    color: white;

    > small {
      font-size: 0.8rem;
      display: block;
      line-height: 0.9;
    }

  }

  .player-position {
    position: absolute;
    left: 0;
    top: 0;
    background: var(--color-black-trans);
    color: white;
    padding: 0.2rem 0.5rem;
    text-align: center;
    font-size: 2.5rem;
    line-height: 3rem;

    i {
      margin-right: 8px;
      font-size: 66%;
    }

    &::before {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      left: 0;
      bottom: -24px;
      border-style: solid;
      border-width: 24px 68px 0 0;
      border-color: var(--color-black-trans) transparent transparent transparent;
    }
  }

  .player-name {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--color-black-trans);
    text-align: right;
    padding: 0.2rem 0.4rem;
    color: white;
    direction: rtl;
    font-size: 2rem;

    > span {
      display: block;
      max-width: calc(100% - 4rem);
    }

    > span:first-child {
      line-height: 1;
    }

    > span:last-child {
      font-size: 66%;
    }
  }
}

.players-item {
  background-color: #101010;
  position: relative;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  outline: 1px solid rgba(0, 0, 0, 0.5);
  outline-offset: -1px;
  background-repeat: no-repeat;

  &.dim {
    opacity: 0.5;
  }

  .players-item {
    @media (max-width: 768px) {
      height: 50vw;
      .player-name {
        font-size: 20px !important;
      }
    }
  }
}

.hide-nav {
  .VueCarousel-navigation {
    display: none;
  }
}

.special-scroll {
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: var(--color-dark);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-secondary);
  }

  &.special-scroll-dark {
    &::-webkit-scrollbar-track {
      background: var(--color-secondary);
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color-dark);
    }
  }
}

.title, .subtitle {
  display: block;
  text-align: center;
  width: 100%;
  color: white;
}

.instructions {
  background: #1C1C1C;
  padding: 15px;
  text-align: center;

  > input {
    color: var(--color-secondary);
    text-align: center;
    font-size: 2rem;
    direction: rtl;
  }
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
}

.overlay-dark {
  background: rgba(0, 0, 0, 0.66);
}

.btn-success {
  background-color: var(--color-green) !important;
}

.hidden-input {
  border: none;
  outline: none;
  background: none;
}

.whitify {
  filter: brightness(4);
}

.boomerang {
  z-index: 1;
  animation: boomerang-player 2.5s normal 0s infinite;
  opacity: 0;
  background: transparent center/cover no-repeat;
}

.overlay-like {
  z-index: 10;
}

@keyframes boomerang-player {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.dg-content {
  text-align: right;
}

.dg-main-content {
  direction: rtl;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .4s ease;
}

.slide-fade-leave-active {
  transition: all .4s ease-in-out;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.popup {
  position: fixed;
  height: auto;
  width: 90%;
  max-width: 480px;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 10px;
  text-align: right;

  .popup-body {
    height: 100%;
    max-height: 90vh;
    padding: 10px;

    input {
      text-align: right;
      padding: 4px 8px;
      font-size: 1.5rem;
      width: 100%;
      direction: rtl;
    }

    button {
      display: block;
      margin-top: 20px;
      width: 100%;
      border: none;
      font-size: 1.5rem;
    }

    .popup-images {
      margin-bottom: 20px;
      direction: rtl;
    }

    p {
      font-size: 14px;
    }
  }
}

h3 {
  margin: 20px 0;
}

.disabled {
  pointer-events: none;
  opacity: .66;
}

.text-under {
  font-size: 14px;
  color: white;
  text-align: right;
  direction: rtl;
}

p.name-error {
  background: rgba(0, 0, 0, 0.5);
  direction: rtl;
  text-align: right;
  color: white;
  font-size: 16px;
}

</style>
